// extracted by mini-css-extract-plugin
export var attachment = "_p4-a";
export var emailContainer = "_p4-4";
export var emailContentPaddedContainer = "_p4-b";
export var emailHeader = "_p4-6";
export var emailIframe = "_p4-3";
export var emailInfoIcon = "_p4-9";
export var emailShortenedSummary = "_p4-e";
export var infoDropdown = "_p4-0";
export var infoRowBoundedContent = "_p4-d";
export var internal = "_p4-5";
export var merchant = "_p4-8";
export var messageInputContainer = "_p4-h";
export var normal = "_p4-7";
export var replyCard = "_p4-f";
export var subtleButton = "_p4-1";
export var subtleButtonIconContainer = "_p4-2";
export var toggleViewRepliesButton = "_p4-c";
export var wrappingText = "_p4-g";